<div class="strength">{{barLabel}}&nbsp;
    <ul class="strengthBar">
      <li class="point" [style.background-color]="bar0"></li>
      <li class="point" [style.background-color]="bar1"></li>
      <li class="point" [style.background-color]="bar2"></li>
      <li class="point" [style.background-color]="bar3"></li>
    </ul>
    <br>
    <p class="alert alert-info" *ngIf="msg" style="padding: 5px 10px;margin-top: 10px;">{{msg}}</p>
  </div>